// https://confluence.rbx.com/display/GS/Eventstream+Guidelines
// Events are camelCase
enum CreatorDashboardEventType {
  // ------------------------------
  // START OF LEGACY EVENTS
  // the following legacy events are still instrumented with trackerClient(the legacy eventstream setup)
  // new events added should be instrumented with unifiedLoggerClient (the new unifed logging framework) instead
  // ------------------------------
  DownloadStudio = 'downloadStudio',
  ExportKpiChart = 'exportKpiChart',
  ViewComputeTab = 'viewComputeTab',
  DateRangeChanged = 'dateRangeChanged',
  DataDivisionChanged = 'dataDivisionChanged',
  PageBreakdownsToggled = 'pageBreakdownsToggled',
  PageVersionAnnotationsToggled = 'pageVersionAnnotationsToggled',
  PageFiltersChanged = 'pageFiltersChanged',
  ChartTooltipViewed = 'chartTooltipViewed',
  PageTabSelected = 'pageTabSelected',
  RbxClientRequest = 'rbxClientRequest',
  StudioStartAttempt = 'studioStartAttempt',
  StudioStartSuccess = 'studioStartSuccess',
  ViewTranslatorPortal = 'viewTranslatorPortal',
  ViewLocalization = 'viewLocalization',
  SelectAddSupportedLanguage = 'selectAddSupportedLanguage',
  ManageSupportedLanguage = 'manageSupportedLanguage',
  LearnMoreAutomaticQuota = 'learnMoreAutomaticQuota',
  ShareLinkTranslators = 'shareLinkTranslators',
  SelectInviteTranslators = 'selectInviteTranslators',
  InviteTranslatorsModel = 'inviteTranslatorsModel',
  DownloadContributorReport = 'downloadContributorReport',
  AutomaticTextCaptureToggled = 'automaticTextCaptureToggled',
  UseTranslatedContentToggled = 'useTranslatedContentToggled',
  ClearAutoCapturedTable = 'clearAutoCapturedTable',
  OpenSwitchOffAutomaticTranslationConfirmDialogue = 'openSwitchOffAutomaticTranslationConfirmDialogue',
  SwitchOffAutomaticTranslation = 'switchOffAutomaticTranslation',
  SwitchOnAutomaticTranslation = 'switchOnAutomaticTranslation',
  UpdateUniverseInformation = 'updateUniverseInformation',
  SelectAddTranslationEntry = 'selectAddTranslationEntry',
  AddTranslationEntry = 'addTranslationEntry',
  SearchTranslationEntryList = 'searchTranslationEntryList',
  FilterTranslationEntryList = 'filterTranslationEntryList',
  FilterTranslationProductList = 'filterTranslationProductList',
  UpdateGameProductTranslation = 'updateGameProductTranslation',
  UpdateGameProductIcon = 'updateGameProductIcon',
  UpdateUniverseIconAndThumbnail = 'updateUniverseIconAndThumbnail',
  ViewNotifications = 'viewNotifications',
  NotificationStringListLoaded = 'notificationStringListLoaded',
  GetNotificationStringsList = 'getNotificationStringsList',
  GetNotificationStringsListSuccess = 'getNotificationStringsListSuccess',
  GetNotificationStringsListFailure = 'getNotificationStringsListFailure',
  GetNotificationString = 'getNotificationString',
  GetNotificationStringSuccess = 'getNotificationStringSuccess',
  GetNotificationStringFailure = 'getNotificationStringFailure',
  ArchiveNotificationContent = 'archiveNotificationContent',
  ArchiveNotificationContentSuccess = 'archiveNotificationContentSuccess',
  ArchiveNotificationContentFailure = 'archiveNotificationContentFailure',
  CopyNotificationContentAssetId = 'copyNotificationContentAssetId',
  CreateNotificationContent = 'createNotificationContent',
  CreateNotificationContentSuccess = 'createNotificationContentSuccess',
  CreateNotificationContentFailure = 'createNotificationContentFailure',
  InitiateCreateNotificationContent = 'initiateCreateNotificationContent',
  InitiateEditNotificationContent = 'initiateEditNotificationContent',
  EditNotificationStringLoaded = 'editNotificationStringLoaded',
  EditNotificationContent = 'editNotificationContent',
  EditNotificationContentSuccess = 'editNotificationContentSuccess',
  EditNotificationContentFailure = 'editNotificationContentFailure',
  ViewNotificationCampaignAnalytics = 'viewNotificationCampaignAnalytics',
  AssetCreationAttempt = 'assetCreationAttempt',
  AssetCreationFailure = 'assetCreationFailure',
  EventCreationExposure = 'exposedToEventCreation',
  EventCreationInitiated = 'initiateEventCreation',
  EventCreationDiscarded = 'discardUnsavedEventChanges',
  EventCreationSaveDraft = 'saveEventAsDraft',
  EventCreationDeleteDraft = 'deleteEventDraft',
  EventCreationPublish = 'publishEvent',
  EventCreationLinkCopied = 'virtualEventLinkCopied',
  NotificationsSettingsCategoryLoad = 'notificationSettingsCategoryLoad',
  NotificationsSettingsLeftNavClick = 'notificationSettingsLeftNavClick',
  NotificationsSettingsCategoryCancelClick = 'notificationsSettingsCategoryCancelClick',
  // ------------------------------
  // END OF LEGACY EVENTS
  // ------------------------------
  DocumentationLanguageChanged = 'documentationLanguageChanged',
  ClickMarketplaceOnboardingCountry = 'clickMarketplaceOnboardingCountry',
  ImpressionCreatorOpportunityTable = 'impressionCreatorOpportunityTable',
  ClickCreatorOpportunityTable = 'clickCreatorOpportunityTable',
  ClickShareLinkPromoApplyNow = 'clickShareLinkPromoApplyNow',
  RightsManagerSearchClick = 'rightsManagerSearchClick',
  RightsManagerSearchResultClick = 'rightsManagerSearchResultClick',
  RightsManagerSearchResultSubmitted = 'rightsManagerSearchResultSubmitted',
  RightsManagerSearchResultsLoad = 'rightsManagerSearchResultsLoad',
  RightsManagerSearchResultsEnd = 'rightsManagerSearchResultsEnd',
  DownloadPlayerFeedbackCommentsClick = 'downloadPlayerFeedbackCommentsClick',
  PageNotFound = 'pageNotFound',
  PageNotFoundReturnButtonClick = 'pageNotFoundReturnButtonClick',
  PlayerFeedbackSummaryClick = 'playerFeedbackSummaryClick',
  AgeVerificationUpsellBanner = 'ageVerificationUpsellBanner',
  AgeVerificationUpsellBannerClick = 'ageVerificationUpsellBannerClick',
  AgeVerificationUpsellBannerError = 'ageVerificationUpsellBannerError',
  BetaTaxonomyToggle = 'betaTaxonomyToggle',
  AssetPrivacyOptOutSurveySubmitted = 'assetPrivacyOptOutSurveySubmitted',
  TalentHubV2JobCardClick = 'talentHubV2JobCardClick',
  UnratedExperienceBanner = 'unratedExperienceBanner',
  UnratedExperienceBannerClick = 'unratedExperienceBannerClick',
  ActivationEligibilityBanner = 'activationEligibilityBanner',
  ActivationEligibilityBannerClick = 'activationEligibilityBannerClick',
  UnifiedAlertImpression = 'unifiedAlertImpression',
  UnifiedAlertClick = 'unifiedAlertClick',
  TalentHubV2FilterChange = 'talentHubV2FilterChange',
  TalentHubV2ApplyClick = 'talentHubV2ApplyClick',
  TalentHubV2StudioCardClick = 'talentHubV2StudioCardClick',
  TalentHubV2ProfileSave = 'talentHubV2ProfileSave',
  TalentHubV2InboxRowClick = 'talentHubV2InboxRowClick',
  TalentHubV2JobsPageView = 'talentHubV2JobsPageView',
  TalentHubV2StudiosPageView = 'talentHubV2StudiosPageView',
  TalentHubV2StudioProfilePageView = 'talentHubV2StudioProfilePageView',
  TalentHubV2TalentProfilePageView = 'talentHubV2TalentProfilePageView',
  TalentHubV2InboxPageView = 'talentHubV2InboxPageView',
  TalentHubV2PostJobPageView = 'talentHubV2PostJobPageView',
  TalentHubV2JobPostSubmit = 'talentHubV2JobPostSubmit',
  TalentHubV2JobEditSubmit = 'talentHubV2JobEditSubmit',
  StatusBadgeClick = 'statusBadgeClick',
  StatusBadgeImpression = 'statusBadgeImpression',
  StatusBadgeTooltipOpen = 'statusBadgeTooltipOpen',
  PublishEligibilityBannerImpression = 'publishEligibilityBannerImpression',
  PublishEligibilityBannerClick = 'publishEligibilityBannerClick',
}

export default CreatorDashboardEventType;
